// docs: https://github.com/altostra/type-validations#readme
import { arrayOf, maybe, objectOf } from "@altostra/type-validations";
import { string } from "@altostra/type-validations/lib/primitives";

const isNestedEcommerceEventProperty = objectOf({
  name: string,
  type: string,
});

export const isEcommerceEventPropertiesResponse = objectOf({
  properties: arrayOf(
    objectOf({
      name: string,
      type: string,
      properties: maybe(arrayOf(isNestedEcommerceEventProperty)),
    })
  ),
});
